import { Tag } from 'primereact';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react'


import Card from '../../../Base/Components/Card/Card'
import { toastShow } from '../../../Base/Services/ToastService';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';
import {  getDatesProduccion } from '../../../Base/Services/Moment/Luxon';
import DialogPassword from '../../../Base/Components/Dialog/DialogPassword/DialogPassword';

import { PermisosDespachosEspeciales, getDespachosLost } from '../../../API/Planning/DespachosEspecialesRequest';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';



const DespachosEspecialesScreen = () => {

    const toast = useRef(null)

    const [list, setList] = useState([]);
    const [password, setPassword] = useState('');
    const [showDialogPassword, setShowDialogPassword] = useState(false);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const [permisoChange, setPermisoChange] = useState(null);
    const [valuePermiso, setValuePermiso] = useState(false);
    const [date, setDate] = useState([new Date(), new Date()])

    const getInfo = async () => {
        setLoading(true);
        const d = getDatesProduccion(date)
        const t = await getDespachosLost(d);
        if (t.length > 0) {
            setList(t);
        }
        setLoading(false)
    }

    const authByUserOrRol = async () => {
        const user = JSON.parse(localStorage.getItem('ppfUser'))
        if(user.IdRol === 1){
            const t = await PermisosDespachosEspeciales({
                Despacho: selected.map(e => e.IdDespacho),
                NoPermiso: permisoChange,
                Permiso: valuePermiso,
                ClaveAutorizacion: 'ppfbv/?'
            })
            verficarRespuesta(t);
        }
    }

    const authPermiso = async () => {
        const t = await PermisosDespachosEspeciales({
            Despacho: selected.map(e => e.IdDespacho),
            NoPermiso: permisoChange,
            Permiso: valuePermiso,
            ClaveAutorizacion: password
        })
        verficarRespuesta(t);
    }
    
    const verficarRespuesta = (t) => {
        if(t.length > 0){
            t.forEach(e => {
                toastShow(toast, e.ESTADO > 0 ? 'success' : 'warn', e.MENSAJE)
            });
        }
        getInfo()
        onHide()
    }

    const onHide = () => {
        setShowDialogPassword(false);
        setPassword('')
    }

    const changePermiso = async (permiso, rowData, e) => {
        setValuePermiso(!e)
        setPermisoChange(permiso)
       if(selected.length === 0){
        setSelected([rowData])
       }
       setShowDialogPassword(true);
    }

    const TipoTemplate = (rowData) => {
        switch (rowData.IdEstado) {
            case 3617:
                return <Tag severity='success' className='col-12' value={rowData.StatusName}  />
                break;
            case 3616:
                return <Tag severity='info' className='col-12' value={rowData.StatusName} />
                break;
            case 3614:
                return <Tag severity='warning' className='col-12' value={rowData.StatusName} />
                break;
            case 3618:
                return <Tag className='col-12' value={rowData.StatusName} />
                break;

            default:
                return <div>{rowData.NombreTipo}</div>
                break;
        }
    }

    const colums = [
        {
            header: 'No Despacho',
            field: 'NoDespacho',
        },
        {
            header: 'Fecha Despacho',
            field: 'FechaDespachoWEB',
            // Format: 'DateTime'
        },
        {
            header: 'Area',
            field: 'Area',
        },
        {
            header: 'Estado',
            field: 'StatusName',
            Format: 'Template',
            body: TipoTemplate,
            className: 'small'
        },
        {
            header: 'Agente',
            field: 'AgentName',
        },
        {
            header: 'Fecha Gerente',
            field: 'FechaFirmaGerenteWeb',
        },
        {
            header: 'Usuario Gerente',
            field: 'UsuarioFirmaGerente',
        },
        {
            header: 'Fecha Logistica',
            field: 'FechaFirmaLogisticaWeb',
        },
        {
            header: 'Usuario Logistica',
            field: 'UsuarioFirmaLogistica',
        },
        {
            header: 'Fecha Finanzas',
            field: 'FechaFirmaFinanzasWeb',
        },
        {
            header: 'Usuario Finanzas',
            field: 'UsuarioFirmaFinanzas',
        },
        {
            header: 'Fecha General',
            field: 'FechaFirmaGeneralWeb',
        },
        {
            header: 'Usuario General',
            field: 'UsuarioFirmaGeneral',
        },
        {
            header: 'Gerente',
            field: 'FirmaGerente',
            frozen: true,
            alignFrozen: 'right',
            Format: 'Checkbox',
            className: 'small',
            onChange: (e, rowData) => changePermiso(1, rowData.data, rowData.data.FirmaGerente)
        },
        {
            header: 'Logistica',
            field: 'FirmaLogistica',
            frozen: true,
            alignFrozen: 'right',
            Format: 'Checkbox',
            className: 'small',
            onChange: (e, rowData) => changePermiso(2, rowData.data, rowData.data.FirmaLogistica)
        },
        {
            header: 'Finanzas',
            field: 'FirmaFinanzas',
            frozen: true,
            alignFrozen: 'right',
            Format: 'Checkbox',
            className: 'small',
            onChange: (e, rowData) => changePermiso(3, rowData.data, rowData.data.FirmaFinanzas)
        },
        {
            header: 'General',
            field: 'FirmaGeneral',
            frozen: true,
            alignFrozen: 'right',
            Format: 'Checkbox',
            className: 'small',
            onChange: (e, rowData) => changePermiso(4, rowData.data, rowData.data.FirmaGeneral)
        },

    ]

    const table = {
        Columns: colums,
        Data: list,
        selected: selected,
        setSelected: setSelected,
        loading: loading
    }


    useEffect(() => {
        getInfo();
        setTitlePage('Despachos especiales')
    }, [])


    return (
        <div>
            <Toast ref={toast}/>
            <Card
                titulo={<div className='d-flex botones' style={{ gap: 10 }}>
                    <h3>Despachos especiales</h3>
                    <CalendarWeek
                        date={date}
                        setDate={setDate}
                        loading={loading}
                        buscar={getInfo}
                        selectionMode='range'
                    />
                </div>}
                contenido={<div className='pt-4' style={{ height: '90vh' }}>
                <DialogPassword
                        display={showDialogPassword}
                        loading={loading}
                        authByUserOrRol={authByUserOrRol}
                        authPermiso={authPermiso}
                        onHide={onHide}
                        password={password}
                        setPassword={setPassword}
                        selected={selected}
                         />
                    <AgGrid table={table} />
                </div>}
            />
        </div>
    )
}

export default DespachosEspecialesScreen